<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title class="project">
            <span class="headline white--text">Copy question from project</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <v-select
                    v-model="project_id"
                    :items="projects"
                    item-text="name"
                    item-value="id"
                    @change="getQuestion($event)"
                    box
                    label="select project"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-checkbox
                    v-for="(question, index) in questions"
                    :key="index"
                    v-model="selectedQuestions"
                    :label="question.question"
                    color="success"
                    :value="question"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="cancel">Close</v-btn>
            <v-btn
              color="blue darken-1"
              :disabled="project_id == ''"
              flat
              @click="submit"
              >Add</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import datadash from "../api/datadash";
export default {
  data: () => ({
    apiUrl: "all-project-list",
    valid: true,
    questions: [],
    selectedQuestions: [],
    projects: [],
    project_id: "",
    other_rule: [
      (v) => !!v || "This field is required",
      (v) => (v && v.length <= 60) || "Input must be less than 60 characters",
    ],
  }),
  computed: {
    ...mapGetters(["token"]),
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.token != null) {
        this.getData();
      }
    },
    async getData() {
      let project_id = JSON.parse(localStorage.getItem("project_id"));
      var response = await datadash.fetchAllData(
        this.token,
        this.apiUrl,
        project_id
      );
      this.projects = response.data.data.allProjects;
      // console.log(this.questions);
    },
    async getQuestion(event) {
      var response = await datadash.fetchAllData(
        this.token,
        "get-project-question",
        event
      );
      this.questions = response.data.data;
      // console.log(response1);
    },
    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
    cancel() {
      // console.log(this.token);
      this.$emit("selectQuestion", false);
    },
    checkOther() {
      if (this.assistantData.services.includes("Other")) {
        return true;
      } else {
        return false;
      }
    },
    submit() {
      // console.log(this.selectedQuestions);
      this.$emit("selectQuestion", this.selectedQuestions);
    },
  },
};
</script>
<style lang="stylus" scoped>
.v-progress-circular {
  margin: 1rem;
}

.imageResize {
  width: auto;
  height: auto;
}

.project {
  background: #ff2e2e;
}
</style>
